// src/components/admin/AdminLayout.js
import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import AdminHeader from './AdminHeader';

const isTokenValid = () => {
  const token = localStorage.getItem('adminToken');
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    // exp saniye cinsinden, Date.now() milisaniye
    if (payload.exp && payload.exp * 1000 < Date.now()) {
      localStorage.removeItem('adminToken');
      return false;
    }
    return true;
  } catch {
    localStorage.removeItem('adminToken');
    return false;
  }
};

const AdminLayout = () => {
  if (!isTokenValid()) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <>
      <AdminHeader />
      <Outlet />
    </>
  );
};

export default AdminLayout;
